export default "__VITE_ASSET__Dq6FlOfL__"